import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        return super.parse(url.toLowerCase());
    }

    serialize(tree: UrlTree): any {
        const dus = new DefaultUrlSerializer();
        const path = dus.serialize(tree);
        let tempPath = '';
        // use your regex to replace as per your requirement.
        tempPath = path.replace(/%3F|%3f/g, '?').replace(/%3D|3d/g, '=');
        return tempPath;
    }
}
